const SET_VALUE = "SET_VALUE";
const SET_VALUE_WC = "SET_VALUE_WC";
const SET_VALUE_PERFORMANCE = "SET_VALUE_PERFORMANCE";
const RESET_FORM = "RESET_FORM";
const INITIALIZE_FORM = "INITIALIZE_FORM";
const SET_DIRTY = "SET_DIRTY";
const SET_DIRTY_WC = "SET_DIRTY_WC";
const SET_EXPANDED_KEYS = "SET_EXPANDED_KEYS";
const INIT_EXPANDED_KEYS = "INIT_EXPANDED_KEYS";
const SET_VALUE_BILLING = "SET_VALUE_BILLING";
const INITIALIZE_FORM_BILLING = "INITIALIZE_FORM_BILLING";

export function setValue(value, valueType, row, column, typeEstimate) {
  return {
    type: SET_VALUE,
    value,
    valueType,
    row,
    column,
    typeEstimate,
  };
}

export function setValuePerformance(value, typeValue, row = "", index = "") {
  return {
    type: SET_VALUE_PERFORMANCE,
    value,
    row,
    index,
    typeValue,
  };
}

export function setValueBilling(value, month, index, typeTable = "billing") {
  return {
    type: SET_VALUE_BILLING,
    value,
    month,
    index,
    typeTable,
  };
}

export function setValueWC(value) {
  return {
    type: SET_VALUE_WC,
    value,
  };
}

export function setDirty(isDirty, who = "") {
  return {
    type: SET_DIRTY,
    isDirty,
    who,
  };
}
export function setDirtyWC(payload) {
  return {
    type: SET_DIRTY_WC,
    payload,
  };
}

export function initializeForm(wbsId, values, expandedKeys = []) {
  return {
    type: INITIALIZE_FORM,
    payload: { wbsId, values, expandedKeys },
  };
}

export function initializeFormBilling(payload) {
  return {
    type: INITIALIZE_FORM_BILLING,
    payload,
  };
}

export function resetForm(which = "all") {
  /**
   * "which" permitted values:
   *  - all => Reset all forms
   *  - billing => Reset only billing form
   *  - custom => reset only custom form
   */
  return {
    type: RESET_FORM,
    which,
  };
}

export function setExpandedKeys(payload) {
  return {
    type: SET_EXPANDED_KEYS,
    payload,
  };
}

export function initExpandedKeys() {
  return {
    type: INIT_EXPANDED_KEYS,
  };
}

const INIT_STATE = {
  isDirty: false,
  isDirtyBilling: false,
  isDirtyWC: false,
  customForm: {},
  customFormBilling: [],
  wbsId: "",
  expandedKeys: [],
};

export default function EditableTableDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_VALUE:
      if (
        newState.customForm[action.row] &&
        newState.customForm[action.row][action.column] &&
        newState.customForm[action.row][action.column]
      ) {
        if (action.valueType === "quantity") {
          if (action.typeEstimate === "cost-estimation") {
            newState.customForm[action.row][action.column].quantityEstimate = action.value;
          } else if (action.typeEstimate === "kick-off") {
            newState.customForm[action.row][action.column].quantityKickOff = action.value;
          }
        } else {
          if (action.typeEstimate === "cost-estimation") {
            newState.customForm[action.row][action.column].amountEstimate = action.value;
          } else if (action.typeEstimate === "kick-off") {
            newState.customForm[action.row][action.column].amountKickOff = action.value;
          }
        }
      }
      break;
    case SET_VALUE_WC:
      newState.isDirty = true;
      newState.customForm = action.value;
      break;
    case SET_VALUE_PERFORMANCE:
      newState.isDirty = true;
      if (action.typeValue === "REVENUE") {
        newState.customForm["REVENUE"].amount = action.value;
      } else if (action.typeValue === "VALUES") {
        newState.customForm[`VALUES-${action.row}`][action.index].amount = action.value;
      }
      break;
    case SET_VALUE_BILLING:
      if (action.typeTable === "billing") {
        newState.isDirtyBilling = true;
        newState.customFormBilling[action.index].amount = action.value;
      } else {
        newState.isDirty = true;
        newState.customForm[action.index].amount = action.value;
      }
      break;
    case INITIALIZE_FORM_BILLING:
      newState.customFormBilling = action.payload;
      newState.isDirtyBilling = false;
      break;
    case SET_DIRTY:
      if (action.who === "") {
        newState.isDirty = action.isDirty;
      } else {
        newState.isDirtyBilling = action.isDirty;
      }
      break;
    case SET_DIRTY_WC:
      newState.isDirtyWC = action.payload;
      break;
    case INITIALIZE_FORM:
      newState.wbsId = action.payload.wbsId;
      newState.isDirty = false;
      newState.customForm = action.payload.values;
      break;
    case SET_EXPANDED_KEYS:
      newState.expandedKeys = action.payload;
      break;
    case INIT_EXPANDED_KEYS:
      newState.expandedKeys = [];
      newState.isDirty = false;
      break;
    case RESET_FORM:
      switch (action.which) {
        case "all":
          newState = INIT_STATE;
          break;
        case "billing":
          newState.customFormBilling = [];
          newState.isDirtyBilling = false;
          break;
        case "custom":
          newState.expandedKeys = [];
          newState.customForm = {};
          newState.wbsId = "";
          newState.isDirty = false;
          break;
      }
      break;
    default:
      break;
  }
  return newState;
}
